<template>
  <div>
    <table>
      <tr v-for="(fields, rowIdx) in items" :key="`row-${rowIdx}`">
        <template v-for="field in fields">
          <td class="border" :key="`name-${field.field_id}`">{{ field.name }}</td>
          <td v-if="field.measure === 'град'" class="border" :key="`value-${field.field_id}`">
            {{ Number(field.value).toFixed(2) }}{{ field.measure }}
          </td>
          <td v-else class="border" :key="`value-${field.field_id}`">{{ field.value }}{{ field.measure }}</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Values",

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  computed: {
    items() {
      return this.$utils.arrayChunk(this.data, 2);
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

td {
  border: thin solid rgba(0, 0, 0, 0.12);
  padding: 3px 5px;
  font-size: 12px;
}
</style>
